/**
 * The header and tab bar are glass floating over the scrolling content, so the content needs to know how tall they are.
 * This publishes `--head-h` and `--tab-h` on every `.screen` (updated when a bar resizes, e.g. when a banner appears).
 */
export function watchGlassBars(): void {
  const ro = new ResizeObserver((entries) => {
    for (const e of entries) {
      const bar = e.target as HTMLElement;
      const screen = bar.parentElement;
      if (!screen) continue;
      screen.style.setProperty(bar.classList.contains("tabbar") ? "--tab-h" : "--head-h", `${Math.ceil(bar.getBoundingClientRect().height)}px`);
    }
  });
  const seen = new WeakSet<Element>();
  const scan = () => {
    document.querySelectorAll(".screen > .safe-top, .screen > .tabbar").forEach((bar) => {
      if (seen.has(bar)) return;
      seen.add(bar);
      ro.observe(bar);
    });
  };
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
}
